import { combineReducers } from '@reduxjs/toolkit';
import activeJobApplicationReducer from './slices/activeJobApplicationsSlice';
import activeShiftsReducer from './slices/activeShiftsSlice';
import authReducer from './slices/authSlice';
import bookmarkedLocumJobsReducer from './slices/bookmarkedLocumJobsSlice';
import jobApplicationsReducer from './slices/jobApplicationsSlice';
import jobsApplicationStatsReducer from './slices/jobApplicationStatsSlice';
import jobsCreatedListReducer from './slices/jobCreatedListSlice';
import locumJobsReducer from './slices/locumJobsSlice';
import locumSingleBookmarkJobReducer from './slices/locumSingleBookmarkJobSlice';
import locumSingleJobReducer from './slices/locumSingleJobSlice';
import verificationReducer from './slices/verificationIdSlice';
import jobPermissionsReducer from './slices/jobPermissionsSlice';
import totalApplicationsCountReducer from './slices/totalApplicationsCountSlice';
import pendingApplicationReducer from './slices/pendingJobApplicationsSlice';
import notificationsReducer from './slices/notificationsSlice';
import bannerNotificationsReducer from './slices/bannerNotificationsSlice';
import interviewMatchReducer from './slices/interviewMatchSlice';
import availabilityCountReducer from './slices/availabilityCountSlice';
import prefrenecesReducer from './slices/preferencesSlice';
import availableLocumsReducer from './slices/availableLocumsSlice';
import invitedJobsreducer from './slices/invitedJobsSlice';
import invitedSingleJobReducer from './slices/invitedSingleJobSlice';
import referralReducer from './slices/referralSlice';
import subscriptionReducer from './slices/subscriptionSlice';

const appReducer = combineReducers({
  auth: authReducer,
  verification: verificationReducer,
  jobsApplicationStats: jobsApplicationStatsReducer,
  jobsCreatedList: jobsCreatedListReducer,
  activeShifts: activeShiftsReducer,
  jobApplications: jobApplicationsReducer,
  activeJobApplications: activeJobApplicationReducer,
  locumJobs: locumJobsReducer,
  locumSingleJobs: locumSingleJobReducer,
  locumSingleBookmarkJobs: locumSingleBookmarkJobReducer,
  bookmarkedLocumJobs: bookmarkedLocumJobsReducer,
  jobPermissions: jobPermissionsReducer,
  totalApplicationsCount: totalApplicationsCountReducer,
  pendingJobApplications: pendingApplicationReducer,
  notifications: notificationsReducer,
  bannerNotifications: bannerNotificationsReducer,
  interviewMatch: interviewMatchReducer,
  availabilityCount: availabilityCountReducer,
  preferences: prefrenecesReducer,
  availableLocums: availableLocumsReducer,
  invitedJobs: invitedJobsreducer,
  invitedSingleJob: invitedSingleJobReducer,
  referral: referralReducer,
  subscription: subscriptionReducer,
});

const rootReducer = (
  state: ReturnType<typeof appReducer> | undefined,
  action: any
) => {
  if (action.type === 'LOGOUT') {
    return appReducer(undefined, action);
  }
  return appReducer(state, action);
};

export default rootReducer;
